import { Box, FormControl, FormLabel, Typography } from "@mui/joy";
import { Dispatch, Fragment, useRef, useState } from "react";
import { FileUpload, FileUploadOptions } from "primereact/fileupload";
import { Avatar } from "primereact/avatar";
import { Galleria } from "primereact/galleria";
import { Tooltip } from "primereact/tooltip";
import { Toast } from "primereact/toast";
import { Tag } from "primereact/tag";
import { Button } from "primereact/button";
import { ProgressBar } from "primereact/progressbar";
import { Grid } from "@mui/material";
import { Dialog } from "primereact/dialog";
import DocumentDetails from "./DocumentDetails";
import { DataView } from "primereact/dataview";
import {
  downloadFile,
  getRecordDocuments,
  removeDocument,
  removeMetaDocument,
  setDocumentHistoryDetails,
} from "../service/documentsService";
import GenericTableView from "./GenericTableView";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { GenericTableColumTypes, GenericTableFilterTypes } from "../enum/TableView";
import { GenericTableColumns } from "../models/GenericTableViewModel";
import { consultantRemove, consultantUpdate } from "../service/consultantService";
import { FilterMatchMode } from "primereact/api";
import { useNavigate } from "react-router-dom";
import { RouteComponentProps } from "../models/RouteComponent";
import { UserTypes } from "../enum/UserTypes";

interface inputPrams {
  record_id: string;
  client_id?: string;
  type:
  | "client"
  | "consultant"
  | "employee"
  | "equipment"
  | "subcontractor"
  | "vehicle"
  | "chemical"
  | "site";
  setGlobalLoader: Dispatch<React.SetStateAction<boolean>>;
  props: RouteComponentProps;
}

export default function S3DocumentsUpload(prams: inputPrams) {
  const navigate = useNavigate();
  const [selectedDocument, setSelectedDocument] = useState({} as any);
  const [visible, setVisible] = useState(false);
  const [reload, setReload] = useState(false);
  const toast = useRef(null as any);
  const dialog = useRef(null as any);

  const baseFilter = {
    name: { value: "", matchMode: FilterMatchMode.CONTAINS },
    s3_path: { value: "", matchMode: FilterMatchMode.CONTAINS },
    expire_at: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.CONTAINS },
  };

  const queryParams: any = {
    record_id: prams.record_id,
    type: prams.type,
    clientId: prams.client_id,
  };

  const addButton = (row: any) => {
    console.log("addButton row == ", row);
    setSelectedDocument(null);
    setVisible(true);
  };

  const itemSelected = (row: any) => {
    setSelectedDocument(row.value);
    // setVisible(true);
    viewSelected(row);
  };

  const viewSelected = (row: any) => {
    setVisible(true);
  };

  const contextItemSelected = (row: any) => {
    setSelectedDocument(row.value);
  };

  const acceptFunc = async () => {
    prams.setGlobalLoader(true);
    const industry = await removeMetaDocument(selectedDocument.id);
    prams.setGlobalLoader(false);
    toast.current.show({
      severity: "success",
      summary: "Document Deleted Successfully",
      life: 3000,
    });
    setReload(!reload);
  };

  const download = async (row: any) => {
    prams.setGlobalLoader(true);
    await downloadFile(selectedDocument.name, selectedDocument.s3_key);
    prams.setGlobalLoader(false);
  };

  const history = async (row: any) => {
    setDocumentHistoryDetails({
      recordId: prams.record_id,
      documentId: selectedDocument.document,
      name: selectedDocument.name,
    });

    let breadcrumbs = prams.props.breadcrumbs;
    breadcrumbs.push({
      label: selectedDocument.name,
      link: "/client-view",
      userType: UserTypes.Client,
    });
    prams.props.setBreadcrumbs(breadcrumbs);
    navigate("/documents-history");
  };

  const deleteConfirm = (row: any) => {
    confirmDialog({
      message: "Are you sure you want to proceed?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => acceptFunc(),
    });
  };

  const contextItems = () => {
    let objArray = [{ label: "Upload", icon: "pi pi-fw pi-upload", command: viewSelected }];
    if (selectedDocument?.s3_key) {
      objArray.push({ label: "View", icon: "pi pi-fw pi-eye", command: download });
    }
    if (selectedDocument?.history) {
      objArray.push({ label: "History", icon: "pi pi-fw pi-history", command: history });
    }
    objArray.push({ label: "Delete", icon: "pi pi-fw pi-trash", command: deleteConfirm });
    return objArray;
  };

  const columns: GenericTableColumns[] = [
    {
      field: "name",
      header: "Document Name",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "status",
      header: "Status",
      type: GenericTableColumTypes.Status,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Boolean,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "required",
      header: "Required",
      type: GenericTableColumTypes.Boolean,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Boolean,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "expire_at",
      header: "Expire On",
      type: GenericTableColumTypes.Date,
      visible: true,
      sort: false,
      filter: false,
    },
    {
      field: "uploaded_on",
      header: "Upload On",
      type: GenericTableColumTypes.Date,
      visible: true,
      sort: false,
      filter: false,
    },
  ];

  return (
    <Fragment>
      <GenericTableView
        reload={reload}
        queryParams={queryParams}
        dataKey="document"
        baseFilters={baseFilter}
        url="meta"
        columns={columns}
        contextItems={contextItems}
        itemSelect={itemSelected}
        contextItemSelected={contextItemSelected}
      />

      <Dialog
        ref={dialog}
        header={
          selectedDocument?.name ? `Upload ${selectedDocument.name} Document` : "Add Document"
        }
        visible={visible}
        style={{ width: "50vw" }}
        onHide={() => {
          setVisible(false);
          setReload(!reload);
        }}
      >
        <DocumentDetails
          setGlobalLoading={prams.setGlobalLoader}
          setReload={setReload}
          reload={reload}
          record={selectedDocument}
          id={selectedDocument?.id}
          record_id={prams.record_id}
          type={prams.type}
          setVisible={setVisible}
          toast={toast}
        />
      </Dialog>

      <ConfirmDialog />

      <Toast ref={toast} />
    </Fragment>
  );
}
